import React, { Component } from 'react'
import Modal from './Modal'
import styled from 'styled-components'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject, observer } from 'mobx-react';
import Parse from 'parse'

class ConfirmContractResendModal extends Component {

  constructor(props) {
		super(props)
		this.state = {
			contract: this.props.contract,
			loading: false,
			success: false,
		}
  }

  open = () => {
    this.child.open()
  }

	componentDidUpdate(prevProps) {
  	if (prevProps.contract !== this.props.contract)
  		this.setState({ contract: this.props.contract, success: false, loading: false })
	}

  resend = () => {
    this.setState({ loading: true })
    Parse.Cloud.run('sendContractReminderMail', { contractId: this.state.contract.objectId }).then(result => {
      this.setState({ success: true, loading: false })
    }).catch(error => {
      this.setState({ success: true, loading: false })
          console.error("error acceptContract", error)
    })
  }


  render() {

    if(!this.state.success)
      return (
        <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
          <Heading>Sind Sie sicher?</Heading>

          <Text style={{marginTop: 20}}>
              Wenn Sie auf "bestätigen" klicken wird der Vertrag erneut an die Kontakt E-Mail des Unternehmens gesendet.
          </Text>

          <LogeButtonSlim
            hoverFontColor={"white"}
            style={{margin: "20px 0"}}
            disabled={ this.state.loading }
            onClick={ this.resend }>
              {!this.state.loading ? "bestätigen" : "Lade..."}
          </LogeButtonSlim><br />
          <a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>abbrechen</a>
        </Modal>
      )
    else
      return(
        <Modal width="500px" height="auto" ref={instance => { this.child = instance; }}>
          <Heading>Erfolgreich gesendet!</Heading>

          <Text style={{marginTop: 20}}>
              Der Kunde wurde erfolgreich daran erinnert den Vertrag zu akzeptieren.
          </Text>

          <LogeButtonSlim
            hoverFontColor={"white"}
            style={{marginTop: 20}}
            onClick={() => { this.child.closeModal() }}>
              schließen
          </LogeButtonSlim><br />
        </Modal>
      )
  }
}

export default ConfirmContractResendModal;

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Modals/ConfirmContractResendModal.js